import { render, staticRenderFns } from "./AreaForm.vue?vue&type=template&id=4db214dd"
import script from "./AreaForm.vue?vue&type=script&lang=js"
export * from "./AreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports